import PropTypes from 'prop-types';
import { Component } from 'react';
// @ts-expect-error untyped module customer-data-objects-ui-components
import ObjectTypeIdType from 'customer-data-objects-ui-components/propTypes/ObjectTypeIdType';
import SendInternalSMSActionMetadata from 'automation-ui-action-features/actions/send-internal-sms/records/SendInternalSMSActionMetadata';
import LogEventRowAction from 'automation-ui-action-features/components/LogEventRowAction';
import SendInternalSMSActionDetail from 'automation-ui-action-features/actions/send-internal-sms/SendInternalSMSActionDetail';
import { jsx as _jsx } from "react/jsx-runtime";
class SendInternalSMSActionHistoryCard extends Component {
  render() {
    const {
      actionLabel,
      actionMetadata,
      flowObjectTypeId
    } = this.props;
    return /*#__PURE__*/_jsx(LogEventRowAction, {
      title: actionLabel,
      content: /*#__PURE__*/_jsx(SendInternalSMSActionDetail, {
        actionMetadata: actionMetadata,
        flowObjectTypeId: flowObjectTypeId
      })
    });
  }
}
SendInternalSMSActionHistoryCard.propTypes = {
  actionLabel: PropTypes.node,
  actionMetadata: PropTypes.instanceOf(SendInternalSMSActionMetadata).isRequired,
  flowObjectTypeId: ObjectTypeIdType
};
export default SendInternalSMSActionHistoryCard;